class HeroSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.track = this.querySelector('.hero-slider__track');
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = this.querySelector('.hero-slider__arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 5000;
    this.transition = this.dataset.transition || 'slide';
    this.timer = null;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.current + 1));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());

    this.addTouchSupport();
    this.start();
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    if (this.transition === 'slide' && this.track) {
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
    }

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  start() {
    if (!this.autoplay || this.slides.length < 2) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  addTouchSupport() {
    let startX = 0;
    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 50) {
        this.go(diff > 0 ? this.current + 1 : this.current - 1);
      }
    }, { passive: true });
  }
}

document.querySelectorAll('.hero-slider').forEach((el) => {
  Object.setPrototypeOf(el, HeroSlider.prototype);
  el.connectedCallback();
});
